export interface IAnnualReportTableList {
    _id: string;
    currentYearDate: string;
    previousYearDate: string;
    company: string;
    currency: string;
    createdAt: Date;
    updatedAt: Date;
    disableSelection?: boolean;
    disableActions: boolean;
    locale: string;
    isSealed: boolean;
}
